export default [{
    text: 'Есть',
    value: true,
}, {
    text: 'Нет',
    value: false,
}];
